import {
    Button,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions, 
    FormGroup,
    FormControlLabel,
    Grid,
} from "@mui/material"

export const translations = {
    "queue_chats": "Chats em Fila",
    "max_queue_chats": "Chats em Fila (máx.)",
    "ongoing_chats": "Chats em Atendimento",
    "max_ongoing_chats": "Chats em Atendimento (máx.)",
    "tma": "TMA",
    "max_tma": "Maior TMA",
    "tme": "TME",
    "max_tme": "Maior TME",
    "tmr": "TMR",
    "max_tmr": "Maior TMR",
    "bot_chats": "Chats no Bot",
    "max_bot_chats": "Chats no Bot (máx.)",
    "whatsapp_active": "WhatsApp (Ativos)",
    "whatsapp_receptive": "WhatsApp (Receptivos)",
}

export default function DashboardChartVisibilityDialog({
	open,
	close,
	visibleCharts,
	setVisibleCharts
}) {
    const handleToggle = (key) => {
        setVisibleCharts((prev) => ({
            ...prev,
            [key]: !prev[key],
        }))
    }

	return (
		<Dialog open={true} onClose={close} maxWidth="sm" fullWidth>
	        <DialogTitle>Gráficos Visíveis</DialogTitle>
	        <DialogContent dividers sx={{ padding: "2rem" }}>
	            <FormGroup>
	                <Grid container spacing={2}>
	                    {Object.keys(visibleCharts).map((key) => (
	                        <Grid xs={6} key={key}>
	                            <FormControlLabel
	                                control={
	                                    <Checkbox
	                                        checked={visibleCharts[key]}
	                                        onChange={() => handleToggle(key)}
	                                    />
	                                }
	                                label={translations[key] ?? key}
	                            />
	                        </Grid>
	                    ))}
	                </Grid>
	            </FormGroup>
	        </DialogContent>
	        <DialogActions>
	            <Button onClick={close}>
	                Fechar
	            </Button>
	        </DialogActions>
	    </Dialog>
	)
}